import Vue from 'vue';
import GeneralHands from '@/services/hands/GeneralHands';
import getHandInfo from '@/services/simulator/get-info-from-combined-cards/get-hand-info';
import setSpecificHandInfo from '@/services/simulator/get-info-from-combined-cards/set-specific-hand-info';
import getDrawInfo from '@/services/simulator/get-info-from-combined-cards/get-draw-info';
import simulator from '@/services/simulator/simulator';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  fiveCardHandValueBetOrdering: [
    'fourOfAKindPlus:royalFlush',
    'fourOfAKindPlus:straightFlush',
    'fourOfAKindPlus:fourOfAKind',
    'fullHouse',
    'flush:nut',
    'flush:secondNut',
    'flush:thirdNut',
    'flush:weak',
    'straight',
    'threeOfAKind:topSet',
    'threeOfAKind:secondSet',
    'threeOfAKind:thirdSet',
    'threeOfAKind:fourthSet',
    'threeOfAKind:middleSet',
    'threeOfAKind:bottomSet',
    'threeOfAKind:trips',
    'twoPair:usingTopBoardCard',
    'twoPair:weak',
    'pair:overpair',
    'pair:tptk',
    'pair:tpgk',
    'pair:tpwk',
    'pair:ppUnderTp',
    'pair:secondPair',
    'pair:middlePair',
  ],
  fiveCardHandBluffOrderingForFlop: [
    'flushDraw:nut',
    'flushDraw:secondNut',
    'flushDraw:thirdNut',
    'flushDraw:weak',
    'oesd',
    'doubleGutshot',
    'pair:weakPair',
    'twoOvercards',
    'gutshot',
    'oneOvercard',
    'highCard:weak',
    'highCard:kingHigh',
    'highCard:aceHigh',
  ],
  fiveCardHandBluffOrderingForTurn: [
    'flushDraw:nut',
    'flushDraw:secondNut',
    'flushDraw:thirdNut',
    'flushDraw:weak',
    'oesd',
    'doubleGutshot',
    'pair:weakPair',
    'twoOvercards',
    'gutshot',
    'oneOvercard',
    'highCard:weak',
    'highCard:kingHigh',
    'highCard:aceHigh',
  ],
  fiveCardHandBluffOrderingForRiver: [
    'highCard:weak',
    'highCard:kingHigh',
    'highCard:aceHigh',
    'pair:weakPair',
    'pair:middlePair',
    'pair:secondPair',
    'pair:ppUnderTp',
  ],

  getTotalNumOnePercentIncrements: function (player, streetToCall) {
    let totalNumOnePercentIncrements = 0;
    let indexForCurrState = this._getIndexForCurrState(streetToCall);

    this.fiveCardHandValueBetOrdering.forEach(function (valueId) {
      if (player.states[indexForCurrState].fiveCardHands.find(valueId).visible) {
        totalNumOnePercentIncrements += 100;
      }
    });

    return totalNumOnePercentIncrements * 5;
  },
  _getIndexForCurrState: function (streetToCall) {
    if (streetToCall === 'flop') {
      return 1;
    } else if (streetToCall === 'turn') {
      return 2;
    } else if (streetToCall === 'river') {
      return 3;
    }
  },

  initializeBettingCriteria: function (bettingCriteria, streetToCall) {
    Vue.set(bettingCriteria[streetToCall], 'allValue', []);
    Vue.set(bettingCriteria[streetToCall], 'threeToOne', []);
    Vue.set(bettingCriteria[streetToCall], 'twoToOne', []);
    Vue.set(bettingCriteria[streetToCall], 'oneToOne', []);
    Vue.set(bettingCriteria[streetToCall], 'oneToTwo', []);

    this.fiveCardHandValueBetOrdering.forEach(function (valueId) {
      for (let valueToBluffRatio in bettingCriteria[streetToCall]) {
        bettingCriteria[streetToCall][valueToBluffRatio].push({
          worstValueId: valueId,
          weightedRange: null,
          equity: null,
        });
      }
    });
  },

  setWeightedRangeForEachBettingCriterion: function (state) {
    let indexForCurrState = this._getIndexForCurrState(state.streetToCall);
    let currentStatesGeneralHands = state.players.find(0).states[indexForCurrState].generalHands;
    let presetCommunityCardsArray = state.presetCommunityCards.getArrayForStateViaStreet(state.streetToCall);

    for (let valueToBluffRatio in state.bettingCriteria[state.streetToCall]) {
      state.bettingCriteria[state.streetToCall][valueToBluffRatio].forEach(function (bettingCriterion) {
        if (state.players.find(0).states[indexForCurrState].fiveCardHands.find(bettingCriterion.worstValueId).visible) {
          this._setWeightedRangeForBettingCriterion(currentStatesGeneralHands, bettingCriterion, valueToBluffRatio, presetCommunityCardsArray, state.streetToCall);
        }
      }, this);
    }
  },
  _setWeightedRangeForBettingCriterion: function (currentStatesGeneralHands, bettingCriterion, valueToBluffRatio, presetCommunityCardsArray, streetToCall) {
    let copyOfCurrentStatesGeneralHands = this.__getCopyOfCurrentStatesGeneralHands(currentStatesGeneralHands);

    this.__selectValueHands(copyOfCurrentStatesGeneralHands, bettingCriterion.worstValueId, presetCommunityCardsArray);
    if (copyOfCurrentStatesGeneralHands.numberOfSpecificHandsInRange === 0) {
      bettingCriterion.weightedRange = null;
    }

    if (valueToBluffRatio !== 'allValue') {
      if (this.__selectBluffHands(copyOfCurrentStatesGeneralHands, valueToBluffRatio, streetToCall, presetCommunityCardsArray) === 'not enough bluffs available') {
        return
      }
    }

    bettingCriterion.weightedRange = copyOfCurrentStatesGeneralHands.weightedRange;
  },
  __getCopyOfCurrentStatesGeneralHands: function (currentStatesGeneralHands) {
    let copyOfCurrentStatesGeneralHands = new GeneralHands();

    currentStatesGeneralHands.forEachSpecificHand(function (specificHand) {
      copyOfCurrentStatesGeneralHands.find(specificHand.string).maxPossibleWeight = specificHand.maxPossibleWeight;
    });
    copyOfCurrentStatesGeneralHands.numberOfPossibleSpecificHands = currentStatesGeneralHands.numberOfPossibleSpecificHands;

    return copyOfCurrentStatesGeneralHands;
  },
  __selectValueHands: function (generalHands, worstValueId, presetCommunityCardsArray) {
    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (this.___isSpecificHandEqualToOrBetterThanWorstValueId(specificHand, worstValueId, presetCommunityCardsArray)) {
        specificHand.weight = 100;
        generalHands.numberOfSpecificHandsInRange++;
      }
    }, this);
  },
  ___isSpecificHandEqualToOrBetterThanWorstValueId: function (specificHand, worstValueId, presetCommunityCardsArray) {
    let valueIds;
    let holeCards;
    let handInfo;
    let drawInfo;

    valueIds = this.____getValueIds(worstValueId);
    holeCards = [ specificHand.firstCard, specificHand.secondCard ];
    handInfo = getHandInfo.run(_.union(holeCards, presetCommunityCardsArray));
    setSpecificHandInfo.run(handInfo, holeCards, presetCommunityCardsArray);
    drawInfo = getDrawInfo.run(holeCards, presetCommunityCardsArray, handInfo, true);

    for (let i = 0; i < valueIds.length; i++) {
      if (utilities.results.matchesFiveCardHandId(valueIds[i], handInfo, drawInfo)) {
        return true;
      }
    }

    return false;
  },
  ____getValueIds: function (worstValueId) {
    let valueIds = [];

    for (let i = 0; i < this.fiveCardHandValueBetOrdering.length; i++) {
      valueIds.push(this.fiveCardHandValueBetOrdering[i]);

      if (this.fiveCardHandValueBetOrdering[i] === worstValueId) {
        break;
      }
    }

    return valueIds;
  },
  __selectBluffHands: function (generalHands, valueToBluffRatio, streetToCall, presetCommunityCardsArray) {
    let numBluffCombosToSelect = this.___getNumBluffCombosToSelect(generalHands, valueToBluffRatio);
    let numTotalCombosToSelect = numBluffCombosToSelect + generalHands.numberOfSpecificHandsInRange;
    let bluffIdOrdering = this.___getBluffIdOrdering(streetToCall);

    for (let i = 0; i < bluffIdOrdering.length; i++) {
      this.___addCombosThatMatchBluffId(generalHands, bluffIdOrdering[i], presetCommunityCardsArray, numTotalCombosToSelect);

      if (generalHands.numberOfSpecificHandsInRange >= numTotalCombosToSelect) {
        break;
      }
    }

    if (generalHands.numberOfSpecificHandsInRange !== numTotalCombosToSelect) {
      return 'not enough bluffs available';
    }
  },
  ___getNumBluffCombosToSelect: function (generalHands, valueToBluffRatio) {
    let numBluffCombosToSelect;

    if (valueToBluffRatio === 'threeToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange / 3;
    } else if (valueToBluffRatio === 'twoToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange / 2;
    } else if (valueToBluffRatio === 'oneToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange;
    } else if (valueToBluffRatio === 'oneToTwo') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange * 2;
    } else {
      throw new Error('Invalid value for valueToBluffRatio');
    }

    return Math.floor(numBluffCombosToSelect);
  },
  ___getBluffIdOrdering: function (streetToCall) {
    if (streetToCall === 'flop') {
      return this.fiveCardHandBluffOrderingForFlop;
    } else if (streetToCall === 'turn') {
      return this.fiveCardHandBluffOrderingForTurn;
    } else if (streetToCall === 'river') {
      return this.fiveCardHandBluffOrderingForRiver;
    } else {
      throw new Error('Invalid value for streetToCall');
    }
  },
  ___addCombosThatMatchBluffId: function (generalHands, bluffId, presetCommunityCardsArray, numTotalCombosToSelect) {
    generalHands.forEachPossibleSpecificHandNotInRange(function (specificHand) {
      if (generalHands.numberOfSpecificHandsInRange >= numTotalCombosToSelect) {
        return;
      }

      if (this.____specificHandMatchesBluffId(specificHand, bluffId, presetCommunityCardsArray)) {
        specificHand.weight = 100;
        generalHands.numberOfSpecificHandsInRange++;
      }
    }, this);
  },
  ____specificHandMatchesBluffId: function (specificHand, bluffId, presetCommunityCardsArray) {
    let holeCards;
    let handInfo;
    let drawInfo;
    let onRiver;

    holeCards = [ specificHand.firstCard, specificHand.secondCard ];
    handInfo = getHandInfo.run(_.union(holeCards, presetCommunityCardsArray));
    setSpecificHandInfo.run(handInfo, holeCards, presetCommunityCardsArray);
    drawInfo = getDrawInfo.run(holeCards, presetCommunityCardsArray, handInfo, true);
    onRiver = presetCommunityCardsArray.length === 5;

    if (!onRiver && this._____specificHandIsAValueHand(handInfo, drawInfo, bluffId)) {
      return false;
    }

    return utilities.results.matchesFiveCardHandId(bluffId, handInfo, drawInfo);
  },
  _____specificHandIsAValueHand: function (handInfo, drawInfo, bluffId) {
    if (bluffId.includes('pair:weakPair')) {
      return false;
    }

    return !(
      utilities.results.matchesFiveCardHandId('highCard:aceHigh', handInfo, drawInfo) ||
      utilities.results.matchesFiveCardHandId('highCard:kingHigh', handInfo, drawInfo) ||
      utilities.results.matchesFiveCardHandId('highCard:weak', handInfo, drawInfo)
    );
  },

  setEquityForBettingCriterion: function (bettingCriterion, presetCommunityCardsArray, heroWeightedRange, numberOfSimulations, rakePercentage, tipPercentage, bettingCriteriaOnePercentIncrementsContainer, incrementCb) {
    let weightedRanges = [ heroWeightedRange, bettingCriterion.weightedRange ];
    let wins;
    let ties;
    let winFractions;
    let equity;

    return simulator
      .getEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, function () {
        incrementCb(bettingCriteriaOnePercentIncrementsContainer);
      })
      .then(function (simulationResults) {
        wins = simulationResults[0].wins;
        winFractions = simulationResults[0].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

        equity = ((wins + winFractions) / numberOfSimulations) * 100;
        equity -= (equity * (rakePercentage / 100)) + (equity * (tipPercentage / 100));
        bettingCriterion.equity = equity;
      })
      .catch(function (e) {
        console.error(e);
      })
    ;
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/breakeven/set-betting-criteria-for-calling.js